module.exports = __webpack_public_path__ + "img/44914992003668.acf97829.png";